<template>
  <div class="app-main-layout">
    <header class="header ma-4 mt-6 mb-6 pa-0 pt-sm-2 pl-sm-4 pb-sm-5 mb-sm-1">
      <div class="d-flex align-center">
        <v-img
          alt="Modulbank"
          class="shrink mr-2"
          contain
          src="@/assets/img/logo.svg"
          transition="scale-transition"
          width="156"
        />
      </div>
    </header>

    <v-main class="block">
      <div class="text-h4">Документы</div>
      <v-row class="mt-1">
        <LegalCol :array="market" :title="'Маркетплейс'" />
        <LegalCol :array="partner" :title="'Партнерская программа'" :className="'partner'" :img="'cheque'" />
      </v-row>
    </v-main>

    <v-expansion-panels class="mt-6 block">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="text-h5">Архивные документы Маркетплейс</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-1">
            <LegalCol :array="arhiveL" />
            <LegalCol :array="arhiveR" />
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import LegalCol from "../components/common/LegalCol.vue";
export default {
  name: "LegalLayout",

  components: { LegalCol },
  data() {
    return {
      arhiveL: [
        {
          link: "https://drive.google.com/file/d/1PqX58LHDMc049_aAuCctYFreH1IOcED_/view?usp=share_link",
          title: "Пакетные услуги для селлеров (с 10.11.2022 по 27.11.2022)",
          text: "Пакетные услуги для селлеров (с 10.11.2022 по 27.11.2022)",
        },

        {
          link: "https://drive.google.com/file/d/1wd-es5XUZReV2Wq230Gso7RpvaqWj4R9/view?usp=share_link",
          title: "Пакетные услуги для селлеров (с 19.01.2023 по 27.01.2023)",
          text: "Пакетные услуги для селлеров (с 19.01.2023 по 27.01.2023)",
        },

        {
          link: "https://drive.google.com/file/d/1HrbYg0qximPCOcf7kB6ulfh_tpSKcjwg/view?usp=share_link",
          title: "Пакетные услуги для селлеров (с 06.02.2023 по 16.02.2023)",
          text: "Пакетные услуги для селлеров (с 06.02.2023 по 16.02.2023)",
        },

        {
          link: "https://drive.google.com/file/d/1T_h9Q-LiYXjPQwKNHQfQQZKegIaGaNJD/view?usp=share_link",
          title: "Пакетные услуги для селлеров (с 01.03.2023 по 23.03.2023)",
          text: "Пакетные услуги для селлеров (с 01.03.2023 по 23.03.2023)",
        },

        {
          link: "https://drive.google.com/file/d/1nzcqaxTcCZM-QYJ_0Qg5XcLRdDOfmuOZ/view?usp=share_link",
          title: "Пакетные услуги для селлеров (с 14.04.2023 до 26.05.2023)",
          text: "Пакетные услуги для селлеров (с 14.04.2023 до 26.05.2023)",
        },

        {
          link: "https://mdl.bz/PN3GQ",
          title: "Пакетные услуги для селлеров (с 14.07.2023 по 03.10.2023)",
          text: "Пакетные услуги для селлеров (с 14.07.2023 по 03.10.2023)",
        },
        {
          link: "https://mdl.bz/PVNVH",
          title: "Пакетные услуги для селлеров (с 01.11.2023 по 29.01.2024)",
          text: "Пакетные услуги для селлеров (с 01.11.2023 по 29.01.2024)",
        },
      ],
      arhiveR: [
        {
          link: "https://drive.google.com/file/d/1TvlZZuV2UTADHgr3yM-dteYl-DngGcLc/view?usp=share_link",
          title: "Пакетные услуги для селлеров (с 25.11.2022 по 19.01.2023)",
          text: "Пакетные услуги для селлеров (с 25.11.2022 по 19.01.2023)",
        },

        {
          link: "https://drive.google.com/file/d/1N3qK80JGpiRRr9eyi6__gq4YDcReLIP4/view?usp=share_link",
          title: "Пакетные услуги для селлеров (с 27.01.2023 по 06.02.2023)",
          text: "Пакетные услуги для селлеров (с 27.01.2023 по 06.02.2023)",
        },

        {
          link: "https://drive.google.com/file/d/1UjU1taDND6V0sPmg4ssb_5upnQ7ZYYv_/view?usp=share_link",
          title: "Пакетные услуги для селлеров (с 16.02.2023 по 01.03.2023)",
          text: "Пакетные услуги для селлеров (с 16.02.2023 по 01.03.2023)",
        },

        {
          link: "https://drive.google.com/file/d/1OMeC65Kwmr1BLR4AggKTlN19BSiIpLch/view?usp=share_link",
          title: "Пакетные услуги для селлеров (с 23.03.2023 до 13.04.2023)",
          text: "Пакетные услуги для селлеров (с 23.03.2023 до 13.04.2023)",
        },
        {
          link: "https://drive.google.com/file/d/1WXORHdk4yCfxOO8L6Sie2n-h0a2ZmjMP",
          title: "Пакетные услуги для селлеров (с 30.05.2023 по 14.07.2023)",
          text: "Пакетные услуги для селлеров (с 30.05.2023 по 14.07.2023)",
        },
        {
          link: "https://mdl.bz/PO47P",
          title: "Пакетные услуги для селлеров (с 03.10.2023 по 01.11.2023)",
          text: "Пакетные услуги для селлеров (с 03.10.2023 по 01.11.2023)",
        },
      ],
      market: [
        {
          link: "https://partner.modulbank.ru/files/market_seller_photo.pdf",
          title: "Цены на услуги фотостудии",
          text: "Цены на услуги фотостудии",
        },
        {
          link: "https://partner.modulbank.ru/files/marketplace_services.pdf",
          title: "Услуги для селлеров в рамках тарифов Селлер и Селлер PRO",
          text: "Услуги для селлеров в рамках тарифов Селлер и Селлер PRO",
        },
        {
          link: "https://partner.modulbank.ru/files/marketplace_services.pdf",
          title: "Пакетные услуги для селлеров",
          text: "Пакетные услуги для селлеров",
        },
        {
          link: "https://partner.modulbank.ru/files/MarketInstitute.pdf",
          title: "МаркетИнститут",
          text: "МаркетИнститут",
        },
        {
          link: "https://partner.modulbank.ru/files/marketplace_oferta.pdf",
          title: "Правила оказания услуг «Сервис Маркетплейс»",
          text: "Правила оказания услуг «Сервис Маркетплейс»",
        },
        {
          link: "https://partner.modulbank.ru/files/tehpartner_oferta.pdf",
          title: "Правила оказания услуг «Вывод на маркетплейсы»",
          text: "Правила оказания услуг «Вывод на маркетплейсы»",
        },
        {
          link: "https://partner.modulbank.ru/files/conference_oferta.pdf",
          title: "Договор-оферта на оказание услуг по участию в бизнес-конференции",
          text: "Договор-оферта на оказание услуг по участию в бизнес-конференции",
        },
        {
          link: "https://partner.modulbank.ru/files/pvz_price.pdf",
          title: 'Тарифы на услуги "Открытие и ведение пунктов выдачи заказов"',
          text: 'Тарифы на услуги "Открытие и ведение пунктов выдачи заказов"',
        },
      ],
      partner: [
        {
          link: "https://partner.modulbank.ru/files/tarrifs_modulpartner.pdf",
          title: "Тарифы партнерской программы",
          text: "Тарифы партнерской программы",
        },
        {
          link: "https://partner.modulbank.ru/files/oferta_modulpartner.pdf",
          title: "Оферта партнерской программы",
          text: "Оферта партнерской программы",
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.block {
  padding: 0px 250px 0px 250px !important;

  @media (max-width: 1600px) {
    padding: 0px 100px 0px 100px !important;
  }
  @media (max-width: 960px) {
    padding: 0px 70px 0px 70px !important;
  }
  @media (max-width: 600px) {
    padding: 0px 20px 0px 20px !important;
  }
}
</style>
